import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const twMerge = extendTailwindMerge({
    extend: {
        classGroups: {
            rounded: [
                { rounded: ['badge', 'control', 'chip', 'tile', 'panel'] },
            ],
            'font-size': [
                {
                    text: [
                        'micro',
                        'label',
                        'value',
                        'body',
                        'title',
                        'heading',
                        'display',
                        'banner',
                    ],
                },
            ],
            shadow: [{ shadow: ['e1', 'e2', 'e3', 'e4'] }],
        },
    },
});

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}
